import React from 'react'

const Layout = ({ children }) => (
  <div>
    <div className="max-w-5xl p-10 mx-auto">
      {children}
    </div>
  </div>
)

export default Layout
